import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, BookOpen, FlaskConical } from 'lucide-react';
export function Transformacion() {
  return <section className="py-24 px-4 bg-[#F0F2EB]" data-id="element-412" data-mp="2zbq21ubgapes">
      <div className="max-w-5xl mx-auto" data-id="element-413" data-mp="3d9y42gncggwt">
        <div className="text-center mb-16" data-id="element-414" data-mp="3dazhgrru1fhp">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-4" data-id="element-415" data-mp="38a1zaf6tolg7">
            ¿Qué cambia cuando tenés el sistema?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-416" data-mp="3m89ou21j4khc">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-417" data-mp="3i7pwdbrwi51j">
            <div className="w-12 h-12 bg-green/10 rounded-xl flex items-center justify-center text-green mb-6" data-id="element-418" data-mp="4tuweaw8es8h">
              <Calendar size={24} data-id="element-419" data-mp="347w3dnw97sc" />
            </div>
            <h3 className="text-xl font-bold text-green mb-4 uppercase tracking-wide" data-id="element-420" data-mp="35sq926aqopo">
              Planificar
            </h3>
            <div className="space-y-4 text-sm" data-id="element-421" data-mp="c4mjcikf4wyh">
              <p className="text-slate" data-id="element-422" data-mp="c3uya1og6hmg">
                <span className="font-bold text-terracota" data-id="element-423" data-mp="c6z93hwf4bm3">Antes:</span> cada
                semana buscás, adaptás, armás.
              </p>
              <p className="text-ink" data-id="element-424" data-mp="m3ltk5ku10nl">
                <span className="font-bold text-green" data-id="element-425" data-mp="m2k7z766wvrm">Con el Mega Pack:</span>{' '}
                abrís, elegís y entrás al aula.
              </p>
              <p className="text-slate pt-4 border-t border-cream-dark" data-id="element-426" data-mp="vs3seh9jwxol">
                Los contenidos están organizados en secuencia lógica, con
                actividades y evaluaciones alineadas a cada unidad. No empezás
                de cero nunca más.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-427" data-mp="19tg4uipi6h5q">
            <div className="w-12 h-12 bg-terracota/10 rounded-xl flex items-center justify-center text-terracota mb-6" data-id="element-428" data-mp="3atbaeg4uxiyj">
              <BookOpen size={24} data-id="element-429" data-mp="3onvm0c6lr462" />
            </div>
            <h3 className="text-xl font-bold text-green mb-4 uppercase tracking-wide" data-id="element-430" data-mp="3kje4kjnpt2yg">
              Enseñar
            </h3>
            <div className="space-y-4 text-sm" data-id="element-431" data-mp="2e1c7j438xw1">
              <p className="text-slate" data-id="element-432" data-mp="3tkm1axal1vqf">
                <span className="font-bold text-terracota" data-id="element-433" data-mp="3tlneb7b5ssas">Antes:</span>{' '}
                encontrás teoría que no tiene contexto latinoamericano.
              </p>
              <p className="text-ink" data-id="element-434" data-mp="1z7w68c8haghg">
                <span className="font-bold text-green" data-id="element-435" data-mp="1z8xg4ddrcwxl">Con el Mega Pack:</span>{' '}
                explicás procesos técnicas con ejemplos reales de tu región,
                formulaciones concretas y parámetros medibles en el taller.
              </p>
              <p className="text-slate pt-4 border-t border-cream-dark" data-id="element-436" data-mp="500orbmvlin8">
                Tus alumnos entienden porque el material habla de productos que
                conocen.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-437" data-mp="3s2dmslzfwog8">
            <div className="w-12 h-12 bg-petrol/10 rounded-xl flex items-center justify-center text-petrol mb-6" data-id="element-438" data-mp="1gcl0wms5snoe">
              <FlaskConical size={24} data-id="element-439" data-mp="3hgna4dwd9vze" />
            </div>
            <h3 className="text-xl font-bold text-green mb-4 uppercase tracking-wide" data-id="element-440" data-mp="3hg3q8rn5oxiq">
              Aplicar
            </h3>
            <div className="space-y-4 text-sm" data-id="element-441" data-mp="3dd7e9js4fznr">
              <p className="text-slate" data-id="element-442" data-mp="38ew4f91ttp5j">
                <span className="font-bold text-terracota" data-id="element-443" data-mp="38i1rkiqwagym">Antes:</span> la
                teoría y la práctica de taller no se conectan.
              </p>
              <p className="text-ink" data-id="element-444" data-mp="2yit13zv8nkh0">
                <span className="font-bold text-green" data-id="element-445" data-mp="2yjvtkc87luz1">Con el Mega Pack:</span>{' '}
                cada contenido tiene su actividad práctica, su ficha técnica y
                su proyecto productivo.
              </p>
              <p className="text-slate pt-4 border-t border-cream-dark" data-id="element-446" data-mp="2kqcwiumovedz">
                El alumno ve la cadena completa: de la materia prima al producto
                terminado, envasado y calculado.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-447" data-mp="2au9tznnxddqi">
          <p className="text-2xl font-serif italic text-ink" data-id="element-448" data-mp="20orqzrg5njom">
            "El mejor docente no es el que más busca.{' '}
            <span className="text-terracota font-bold not-italic" data-id="element-449" data-mp="25mbgxom7tkwe">
              Es el que mejor enseña.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}